/* global axios */
import ApiClient from '../ApiClient';

class AciTelephonyAPI extends ApiClient {
  constructor() {
    super('asterisk', { accountScoped: true });
  }

  /**
   * Get current user's SIP credentials for WebRTC
   * GET /api/v1/accounts/:account_id/asterisk/my_extension
   *
   * @returns {Promise<Object>} SIP credentials
   */
  getMyExtension() {
    return axios.get(`${this.url}/my_extension`);
  }

  /**
   * Pull (take over) an AI voice call — agent assumes control.
   * POST /api/v1/accounts/:account_id/asterisk/ai_sessions/pull
   */
  pullAISession(uuid, agentExtension, conversationId) {
    return axios.post(`${this.url}/ai_sessions/pull`, {
      uuid,
      agent_extension: agentExtension,
      conversation_id: conversationId,
    });
  }
}

export default new AciTelephonyAPI();
